import { render, staticRenderFns } from "./CostsPerBrief.vue?vue&type=template&id=034a05e6"
import script from "./CostsPerBrief.vue?vue&type=script&lang=js"
export * from "./CostsPerBrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports